import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    Container,
    Grid,
    Button,
    MenuItem,
    Box,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_SELECT_VALID,
} from 'Components/Helper/Messages';

import { LOGOUT } from 'ConstComponents';
import { SelectByID as TRANSACTION_SELECT_BY_ID, OnboardtoNSDL as STATUS_UPDATE } from 'Components/Api/NSDLOnboardingAPI';
import { StatusDataDisplay } from 'Pages/InnerPages/NSDLOnboarding/OnboardingDataDisplay';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const StatusEdit = ({ OnbaordingID, onDismissCallback }) => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const formikRef = useRef();

    const [formObject, setFormObject] = useState({
        OnboardingID: OnbaordingID,
        Status: '0',
        Remark: ''
    });
    const [headerStatus, setheaderStatus] = useState();

    const OnChange = (name, value, setFieldValue) => {
    };

    useEffect(() => {
        selectByID(OnbaordingID);
    }, [OnbaordingID]);

    const selectByID = async (OnbaordingID) => {

        let JSONObj = {
            OnboardingID: OnbaordingID
        };
        setLoading(true);
        var request = JSON.stringify(JSONObj);

        const response = await TRANSACTION_SELECT_BY_ID(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setheaderStatus(data);
    };

    const UpdateStatus = async (requestObj) => {
        setLoading(true);
        setIsError(false);

        var response = await STATUS_UPDATE(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();


        let parsedOnbaording = JSON.parse(requestObj);
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            selectByID(parsedOnbaording.OnboardingID);
            return;
        }
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);
        onDismissCallback(false);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        setSubmitting(false);


        var requestObj = JSON.stringify(values);
        UpdateStatus(requestObj);
        setSubmitting(true);
        resetForm(formObject);
    };

    const FormValidationSchema = Yup.object({
        Status: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'Status')
            .required(PLEASE_SELECT_VALID + 'Status'),
        Remark: Yup.string()
            .required('Remark is required')
            .max(500, 'Remark can be at most 500 characters')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <StatusDataDisplay headerStatus={headerStatus} />


            <Formik
                innerRef={formikRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={formObject}
            >
                {({ setFieldValue }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <MaterialSelect
                                            label="Select Status"
                                            name="Status"
                                            onCustomCallback={(name, value) => {
                                                OnChange(
                                                    name,
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                        >
                                            <MenuItem key="0" value="0">
                                                Select Type
                                            </MenuItem>

                                            <MenuItem
                                                key="ACCEPT"
                                                value="ACCEPT"
                                            >
                                                ACCEPT
                                            </MenuItem>
                                            <MenuItem
                                                key="REJECT"
                                                value="REJECT"
                                            >
                                                REJECT
                                            </MenuItem>
                                        </MaterialSelect>
                                    </Grid>

                                    {/* Remark Field - 4 columns */}
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <MaterialTextField
                                            label="Remark"
                                            name="Remark"
                                            type="text"
                                            length={500}
                                            placeholder="Remark"
                                        />
                                    </Grid>

                                    {/* Buttons Container - 4 columns total */}
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <Grid container spacing={2}>
                                            {/* Update Button - 2 columns */}
                                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                                <Button
                                                    type="submit"
                                                    title="Update"
                                                    className={classes.CustomPrimaryButtonStyle}
                                                    disabled={loading}
                                                    fullWidth
                                                    style={{
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Submit
                                                    {loading && (
                                                        <CircularProgress
                                                            size={20}
                                                            style={{ marginLeft: 8 }}
                                                        />
                                                    )}
                                                </Button>
                                            </Grid>

                                            {/* Reset Button - 2 columns */}
                                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                                <Button
                                                    onClick={() => {
                                                        if (formikRef.current) {
                                                            formikRef.current.resetForm({ values: formObject });
                                                        }
                                                    }}
                                                    className={classes.CustomDangerButtonStyle}
                                                    fullWidth
                                                    style={{
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
